import React from 'react';
import { IProduct } from 'base/interfaces/product';
import { Rate } from '@base/lib/Rate';
import { useStore, observer } from 'base/store';

export type RateType = 'simple' | 'detailed';
export type ListProductRateProps = {
    product: IProduct;
    type?: RateType;
};

const ListProductRate: React.FC<ListProductRateProps> = props => {
    const { userStore } = useStore();
    if (userStore.isDealer()) {
        return null;
    }

    const {
        product: {
            reviewNum = 0,
            reviewScore = 0
        },
        type = 'detailed',
    } = props;

    return (
        <Rate
            className="rate"
            value={Number(reviewScore)}
            total={reviewNum}
            type={type}
            starSize={'1em'}
        />
    )
};

export default observer(ListProductRate);